import { z } from 'zod'

export const ADMINFORMSREVISIONSGET_CONTRACT_VERSION = '1.0.0' as const
export const adminFormsRevisionsGetResponseSchema = z.unknown()
export type AdminFormsRevisionsGetResponse = z.infer<typeof adminFormsRevisionsGetResponseSchema>
